import type { IconDefinition } from '@fortawesome/sharp-solid-svg-icons';
import { faList, faRefresh } from '@fortawesome/sharp-solid-svg-icons';
export function SCTableRowMenuButton(onClick) {
  return {
    Title: 'Menu',
    Icon: faList,
    Cancel: true,
    OnClick: onClick,
  };
}

export function SCTableRowRefreshButton(onClick) {
  return {
    Title: 'Refresh',
    Icon: faRefresh,
    Cancel: true,
    OnClick: onClick,
  };
}

export function SCTableRowFieldButton(onClick) {
  return {
    Title: 'Fields',
    Icon: faList,
    Cancel: true,
    OnClick: onClick,
  };
}

//NOTE: icon is type IconDefinition but not working with TS?
export function SCTableRowButton(title: string, icon: IconDefinition, onClick) {
  return {
    Title: title,
    Icon: icon,
    Cancel: true,
    OnClick: onClick,
  };
}
